<template><svg xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" viewBox="0 0 47.5 34.4" width="48" height="35">
  <svg:style type="text/css">
	.st0{fill:none;stroke:currentColor;stroke-width:2.38;stroke-linecap:round;stroke-linejoin:round;}
	.st1{fill:currentColor;}
</svg:style>
  <g transform="translate(1.01 0.55)">
    <path transform="translate(0.18 0.64)" class="st0" d="M26.5,6.2V0H0v32h22.2" />
    <path class="st1" d="M20.6,23.1l7.9-7.9l2,2l-7.9,7.9L20.6,23.1z" />
    <path class="st1" d="M23.7,26.2l7.9-7.9l1.4,1.4l-7.9,7.9L23.7,26.2z" />
    <path class="st1" d="M18.1,20.6l7.9-7.9l1.4,1.4L19.5,22L18.1,20.6z" />
    <path class="st1" d="M23,28l-5.4-5.4v3.5l2.1,2L23,28z" />
    <path class="st1" d="M26.6,12l1.8-1.8l7,7L33.7,19L26.6,12z" />
  </g>
</svg>
</template>